import S from 'common/service/sanctuary';

const scopedType$ = (namespace, type) => `@${namespace}/${type}`;

export const scopedType = S.curry2(scopedType$);

const factory$ = (namespace, types) => S.map(
  scopedType(namespace),
  types,
);

export const factory = S.curry2(factory$);

export default factory;
